<template>
  <el-card class="box-card mb-35 box-search profit-screen">
    <span class="tilte-search">{{ $t('profits.staff.search_title', [this.data.total, this.quantityAll]) }}</span>
    <el-form ref="listQuery" :model="dataSearch" @submit.prevent="search" class="form-search mt-20">
      <el-form-item prop="text" v-if="this.role != this.$userRole.partner.shop">
        <el-input :placeholder="(site == $siteType.site_partner) ? $t('profits.shop.partner.placeholder_search_text') : $t('profits.shop.placeholder_search_text')" v-model="dataSearch.text"/>
      </el-form-item>
      <profit-search-date @search-by-date="searchByDate" :key="reset" :listYear="listYear"></profit-search-date>
      <div v-if="this.role != this.$userRole.partner.shop">
        <el-button class="btn-add-search" @click="addSearch">{{ $t('profits.add_search' )}}</el-button>
        <table class="condition-search" v-if="showAddCondition">
          <tr>
            <td class="el-col field-search">
              <span class="font-weight-700">{{ this.$t('profits.area') }}</span> <br>
              <el-link :underline="false" class="btn-add-edit" @click="handleOpenDialogSelectArea">
                {{ $t('profits.add_edit')}}
              </el-link>
            </td>
            <td class="el-col data">
              <el-checkbox-group class="checkbox-search" v-model="listAreaId">
                <el-checkbox :label="item.id" :key="item.id" v-for="item in areaSelected">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr>
            <td class="el-col field-search">
              <span class="font-weight-700">{{ this.$t('profits.shop.genres') }}</span> <br>
              <el-link :underline="false" class="btn-add-edit" @click="handleOpenDialogSelectGenre">
                {{ $t('profits.add_edit')}}
              </el-link>
            </td>
            <td class="el-col data">
              <el-checkbox-group class="checkbox-search" v-model="listGenreId">
                <el-checkbox :label="item.id" :key="item.id" v-for="item in genreSelected">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr>
            <td class="el-col field-search">
              <span class="font-weight-700">{{ this.$t('profits.shop.seats') }}</span> <br>
            </td>
            <td class="el-col data">
              <el-checkbox-group class="checkbox-search" v-model="dataSearch.filters[4].data">
                <el-checkbox :label="item.id" :key="item.id" v-for="item in seats">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
        </table>
      </div>
      <el-form-item :class="this.role != this.$userRole.partner.shop ? 'mt-20' : '' ">
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{ $t('btn_search') }}</el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </el-form-item>
    </el-form>
    <span class="close-result" @click="handleShowResultSearch">
      {{ showDataSearch ? $t('profits.close_result_search') :  $t('profits.open_result_search') }}
    </span>
  </el-card>
  <overview-profit
    :dataOverView="dataOverView"
    :searchConditionText="searchConditionText"
    :type="$typeProfit.staff"
    :showOverview="showOverview"
    :key="showOverview"
    @handle-show="handleShowOverview"
  >
  </overview-profit>
  <list-profit-data
    :columns="columns"
    :data="data"
    :loading="loading"
    :title="$t('profits.staff.title')"
    :searchConditionText="searchConditionText"
    @export-data="handleOpenDialogExport"
    @sort="sort"
    @change-page="handleChangePage"
    @handle-show="handleShowList"
    :showList="showList"
    :key="showList"
  >
  </list-profit-data>
  <dialog-export-data
    v-if="openPopupExport"
    :openPopupExport="true"
    :type="this.$typeProfit.staff"
    :role="role"
    :site="site"
    :company="company"
    :shop="shop"
    @handle-export-data="handleExportData"
    @close-dialog-export="closeDialogExport"
  >
  </dialog-export-data>
  <dialog-select-area
    v-if="openDialogSelectArea"
    :openDialogSelectArea="true"
    :prefecturesGroup="prefectures"
    :areaSelected="areaSelected"
    :urls="urls"
    :isClear="clear"
    @close-dialog-select-area="closeDialogSelectArea"
    @set-list-area="setListArea"
  >
  </dialog-select-area>
  <dialog-select-genre
    v-if="openDialogSelectGenre"
    :openDialogSelectGenre="true"
    :genresGroup="genres"
    :genreCategories="genrecategories"
    :urls="urls"
    :isClear="clear"
    :selected="listGenreSelected"
    @close-dialog-select-genre="closeDialogSelectGenre"
    @set-list-genre="setListGenre"
  >
  </dialog-select-genre>
</template>

<script>
  import { getListStaffProfit } from '../../../api/profit'

  export default {
    props: {
      seats: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      prefectures: { type: Object, required: true, default: {} },
      genres: { type: Object, required: true, default: {} },
      genrecategories: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
      role: { type: Number, required: false },
      company: { type: Object, required: false, default: {} },
      shop: { type: Number, required: false, default: 0 },
    },
    data() {
      return {
        listQuery: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'period_start', 'data': '' },
            { 'key': 'period_end', 'data': '' },
            { 'key': 'prefecture_ids', 'data': [] },
            { 'key': 'genres', 'data': [] },
            { 'key': 'seats', 'data': [] },
          ]
        },
        data: {},
        columns: [
          { prop: "shop_name", label: this.$t('profits.staff.columns.shop_name'), sortable: false, class: "limit-text" },
          { prop: "staff_fullname", label: this.$t('profits.staff.columns.staff_fullname'), sortable: "custom", class: "" },
          { prop: "genre_name", label: this.$t('profits.staff.columns.genre_name'), sortable: "custom", class: "" },
          { prop: "seat_name", label: this.$t('profits.staff.columns.seat_name'), sortable: "custom", class: "" },
          { prop: "profits", label: this.$t('profits.staff.columns.profits'), sortable: "custom", class: "", width: "" }
        ],
        sortProp: { key: 'created_at', dir: 'descending' },
        loading: false,
        showDataSearch: true,
        openPopupExport: false,
        openDialogSelectArea: false,
        showAddCondition: true,
        areaSelected: [],
        listAreaSelected: [],
        dataOverView: {
          totalPoint: 0,
          totalMoney: 0,
          pointOfCompany: 0,
          moneyOfCompany: 0,
          pointOffAxis: 0,
          moneyOffAxis: 0,
          totalRecord: 0,
        },
        searchConditionText: {
          result: 0,
          condition: [
            `${this.$t('profits.period')}: ${this.$t('profits.no_selected')}`,
            `${this.$t('profits.area')}: ${this.$t('profits.no_selected')}`,
            `${this.$t('profits.genres')}: ${this.$t('profits.no_selected')}　　${this.$t('profits.seats')}: ${this.$t('profits.no_selected')}`,
          ]
        },
        listAreaId: [],
        reset: false,
        clear: false,
        openDialogSelectGenre: false,
        genreSelected: [],
        listGenreSelected: [],
        listGenreId: [],
        quantityAll: 0,
        showList: true,
        showOverview: true,
        dataSearch: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'period_start', 'data': '' },
            { 'key': 'period_end', 'data': '' },
            { 'key': 'prefecture_ids', 'data': [] },
            { 'key': 'genres', 'data': [] },
            { 'key': 'seats', 'data': [] },
          ]
        },
      }
    },
    methods: {
      addSearch() {
        this.showAddCondition = !this.showAddCondition;
      },

      searchByDate(data) {
        this.dataSearch.filters[0].data = data.periodStart;
        this.dataSearch.filters[1].data = data.periodEnd;
      },

      handleChangePage(page) {
        this.loading = true;
        this.getListData(page);
      },

      search() {
        this.loading = true;
        this.getListPrefectureIds();
        this.getListGenreIds();
        this.listQuery = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
        this.getListData();
      },

      sort(sortProps) {
        this.sortProp = { key: sortProps.prop, dir: sortProps.order };
        this.getListData();
      },

      handleShowResultSearch() {
        if (!this.showList && !this.showOverview) {
          this.showList = true;
          this.showOverview = true;
        } else {
          this.showList = false;
          this.showOverview = false;
        }
        this.showDataSearch  = this.showList || this.showOverview;
      },

      handleOpenDialogExport() {
        this.openPopupExport = true;
      },

      handleExportData(filters, nameItemSelected) {
        const params = {
          filters: JSON.stringify(filters),
          file_name: this.$t('profits.dialog_export.staff_profit_filename', [this.$dayjs(filters[0].data).format('YYMM'), nameItemSelected])
        };
        const queryParams = new URLSearchParams(params);

        window.location.href = `${this.urls.export}?${queryParams}`
      },

      handleOpenDialogSelectArea() {
        this.openDialogSelectArea = true;
      },

      closeDialogExport() {
        this.openPopupExport = false;
      },

      closeDialogSelectArea() {
        this.openDialogSelectArea = false;
      },

      setListArea(areaSelected) {
        this.listAreaSelected = [];
        this.listAreaId = [];
        this.openDialogSelectArea = false;
        this.listAreaSelected = areaSelected;
        this.areaSelected = [];
        this.clear = false;

        Object.keys(areaSelected).forEach((key,index) => {
          if (areaSelected[key].length == this.prefectures[key].length) {
            this.areaSelected.push({id: key, name: key});
          } else {
            const tmpPrefectures= this.prefectures[key].filter(e => {
              return areaSelected[key].includes(e.id);
            });
            this.areaSelected = [...this.areaSelected, ...tmpPrefectures]
              .filter((value, index, self) =>
                index === self.findIndex((t) => (
                  t.id === value.id && t.name === value.name && t.region_id === value.region_id
                ))
              );
          }
        });

        this.areaSelected = this.areaSelected.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.id === value.id && t.name === value.name
          ))
        )

        this.areaSelected.forEach(e => {
          this.listAreaId.push(e.id)
        })
      },

      getListData(page=1) {
        this.listQuery.page = page
        const query = {...this.listQuery, ...this.sortProp};
        query.filters = JSON.stringify(this.listQuery.filters);

        getListStaffProfit(query)
        .then(response => response.json())
        .then(response => {
          response.data.list.records = response.data.list.records.map(e => {
            return {
              ...e,
              profits: this.convertProfit(e.point),
              staff_fullname: this.convertStaffName(e.staff_fullname),
              shop_name: this.convertShopName(e.shop_name, e.prefecture_name)
            }
          });
          this.data = response.data.list;
          this.dataOverView = {
            totalPoint: response.data.total_point,
            totalMoney: response.data.total_money,
            pointOfCompany: response.data.point_of_company,
            moneyOfCompany: response.data.money_of_company,
            pointOffAxis: response.data.point_off_axis,
            moneyOffAxis: response.data.money_off_axis,
            totalRecord: response.data.list.total,
          };
          this.searchConditionText = {
            result: response.data.list.total,
             condition: [
              `${this.$t('profits.period')}: ${this.setTextPeriodFilter()}`,
              `${this.$t('profits.area')}: ${this.setTextAreaSelected()}`,
              `${this.$t('profits.genres')}: ${this.setTextGenreSelected()}　${this.$t('profits.seats')}: ${this.setNameSeatsSelected()}`,
            ]
          };
          this.quantityAll = response.data.all;
          this.loading = false;
        })
        .catch((error) => {})
      },

      convertShopName(shopName, prefecture) {
        return `<span class="limit-text">${shopName}</span></br>
            <span>${prefecture}</span>`;
      },

      convertProfit(point) {
        return `<span>${point}</span>`;
      },

      convertStaffName(name) {
        return `<span class="staff-name">${name}</span>`;
      },

      setNameSeatsSelected() {
        const listSeatsSelected =  this.seats.filter(e => { return this.listQuery.filters[4].data.includes(e.id); });
        const listSeatsNameSelected = listSeatsSelected.map(e => { return e.name });

        return listSeatsNameSelected.length > 0 ? listSeatsNameSelected.join('・') : this.$t('profits.no_selected');
      },

      setTextPeriodFilter() {
        if (!this.listQuery.filters[0].data && !this.listQuery.filters[1].data) {
          return this.$t('profits.no_selected');
        }

        const periodStartText = this.listQuery.filters[0].data ? this.$dayjs(this.listQuery.filters[0].data).format('YY/MM/DD') : this.$t('profits.no_selected');
        const periodEndText = this.listQuery.filters[1].data ? this.$dayjs(this.listQuery.filters[1].data).format('YY/MM/DD') : this.$t('profits.no_selected');

        return `${periodStartText} 〜 ${periodEndText}`;
      },

      resetForm() {
        this.dataSearch =  {
          page: 1,
          text: "",
          filters: [
            { 'key': 'period_start', 'data': '' },
            { 'key': 'period_end', 'data': '' },
            { 'key': 'prefecture_ids', 'data': [] },
            { 'key': 'genres', 'data': [] },
            { 'key': 'seats', 'data': [] },
          ]
        },
        this.reset = !this.reset;
        this.clear = true;
        this.listAreaId = [];
        this.areaSelected = [];
        this.genreSelected = [];
        this.listGenreId = [];
      },

      getListPrefectureIds() {
        this.dataSearch.filters[2].data = [];
        this.listAreaId.forEach(item => {
          if (Object.keys(this.listAreaSelected).some(key => key === item)) {
            this.dataSearch.filters[2].data.push(...this.listAreaSelected[item]);
          } else {
            this.dataSearch.filters[2].data.push(item);
          }
        });
      },

      setTextAreaSelected() {
        const textArea = [];
        this.listAreaId.forEach(item => {
          if (Object.keys(this.areaSelected).some(key => key === item)) {
            textArea.push(item);
          } else {
            const areas = this.areaSelected.filter(e => {
              return e.id == item;
            });
            const listAreaName = areas.map(item => item.name);
            textArea.push(...listAreaName)
          }
        });

        return textArea.length > 0 ? textArea.join('・') : this.$t('profits.no_selected');
      },

      handleOpenDialogSelectGenre() {
        this.openDialogSelectGenre = true;
      },

      closeDialogSelectGenre() {
        this.openDialogSelectGenre = false;
      },

      setListGenre(genreSelected) {
        this.listGenreSelected = [];
        this.listGenreId = [];
        this.openDialogSelectGenre = false;
        this.listGenreSelected = genreSelected;
        this.genreSelected = [];
        this.clear = false;

        Object.keys(genreSelected).forEach((key,index) => {
          if (genreSelected[key].length == this.genres[key].length) {
            this.genreSelected.push({id: key, name: key});
          } else {
            const tmpGenres= this.genres[key].filter(e => {
              return genreSelected[key].includes(e.id);
            });
            this.genreSelected = [...this.genreSelected, ...tmpGenres]
              .filter((value, index, self) =>
                index === self.findIndex((t) => (
                  t.id === value.id && t.name === value.name && t.genre_category_id === value.genre_category_id
                ))
              );
          }
        });

        this.genreSelected = this.genreSelected.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.id === value.id && t.name === value.name
          ))
        )

        this.genreSelected.forEach(e => {
          this.listGenreId.push(e.id)
        });
      },

      setTextGenreSelected() {
        const textGenre = [];
        this.listGenreId.forEach(item => {
          if (Object.keys(this.genreSelected).some(key => key === item)) {
            textGenre.push(item);
          } else {
            const genres = this.genreSelected.filter(e => {
              return e.id == item;
            });
            const listGenreName = genres.map(item => item.name);
            textGenre.push(...listGenreName)
          }
        });

        return textGenre.length > 0 ? textGenre.join('・') : this.$t('profits.no_selected');
      },

      getListGenreIds() {
        this.dataSearch.filters[3].data = [];
        this.listGenreId.forEach(item => {
          if (Object.keys(this.listGenreSelected).some(key => key === item)) {
            this.dataSearch.filters[3].data.push(...this.listGenreSelected[item]);
          } else {
            this.dataSearch.filters[3].data.push(item);
          }
        });
      },

      handleShowList() {
        this.showList = !this.showList;
        this.showDataSearch  = this.showList || this.showOverview;
      },

      handleShowOverview() {
        this.showOverview = !this.showOverview;
        this.showDataSearch  = this.showList || this.showOverview;
      },
    },

    created() {
      this.getListData(1);
    },
  }
</script>

<style lang="scss" scoped>
  .el-form {
    width: 100%;
  }

  .el-input {
    width: 400px;
  }

  .form-search {
    .el-checkbox {
      --el-checkbox-checked-bg-color: #AC3B29;
      --el-checkbox-input-border-color-hover: #AC3B29;
      --el-checkbox-checked-icon-color: #FFFF;
      --el-checkbox-checked-input-border-color: #AC3B29;
    }
  }

  .btn-add-search {
    width: 167px;
    height: 35px;
    background: #969696 0% 0% no-repeat padding-box;
    font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
    letter-spacing: 1.3px;
    color: #FFFFFF;
    --el-button-hover-bg-color: #969696;
    --el-button-hover-text-color: #FFFFFF;
  }

  .close-result {
    text-decoration: underline;
    font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
    letter-spacing: 1.1px;
    color: #969696;
    margin-top: 16px;
    cursor: pointer;
    display: inline-block;
    line-height: unset;
  }

  .condition-search {
    border: 1px solid #DDD8D1;
    margin-top: 30px;
    border-collapse: collapse;
    width: 100%;
    tr {
      height: 124px;
    }
    td {
      border: 1px solid #DDD8D1;
      vertical-align: top;
    }
    .field-search {
      background: #F7F3ED 0% 0% no-repeat padding-box;
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
      min-height: 60px;
      width: 105px;
      padding: 20px;
      .btn-add-edit {
        font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
        letter-spacing: 1.1px;
        color: #1E65A2;
      }
    }
    .data {
      border-left: none;
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
      width: auto;
      padding: 20px 25px;
      .checkbox-search {
        .el-checkbox {
          --el-checkbox-checked-bg-color: #AC3B29;
          --el-checkbox-input-border-color-hover: #AC3B29;
          --el-checkbox-checked-icon-color: #FFFF;
          --el-checkbox-checked-input-border-color: #AC3B29;
          --el-checkbox-font-size: 11px !important;
          line-height: unset;
          height: unset;
        }
      }
    }
  }
</style>
